// extracted by mini-css-extract-plugin
export default {"item":"mjOnj","image":"w9I9v","correct":"oxV0Q","correctText":"w8Wc0","text":"Vs9L9"};